import BaseAPIService from "./BaseAPIService";

export default class GroupService extends BaseAPIService {
  constructor() {
    super();
  }

  async getGroupById(id) {
    const query = require("../graphql/queries/group.gql");
    const variables = { id };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.group;
  }

  async getGroupExperiences(id, limit = 8, page = 1) {
    const variables = {
      id,
      limit,
      page,
    };
    const query = require("../graphql/queries/groupExperiences.gql");
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.groupExperiences;
  }

  async getJoinableGroups(variables) {
    const query = require("../graphql/queries/joinableGroups.gql");
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.joinableGroups;
  }

  async getGroupContentApproval(id) {
    const query = require("../graphql/queries/groupContentApproval.gql");
    const variables = { id };
    const options = {
      query,
      variables,
    };
    const res = await this.query(options);
    return res.data.groupContentApproval;
  }

  async getGroupContentApprovalByContentId(contentId) {
    const query = require("../graphql/queries/groupContentApprovalByContentId.gql");
    const variables = { contentId };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.groupContentApprovalByContentId;
  }

  async requestGroupContentApproval(variables) {
    const mutation = require("../graphql/mutations/requestGroupContentApproval.gql");
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.requestGroupContentApproval;
  }

  async updateGroupContentApprovalStatus(id, status) {
    const mutation = require("../graphql/mutations/updateGroupContentApprovalStatus.gql");
    const variables = { id, status };
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.updateGroupContentApprovalStatus;
  }
}
